<template>
  <div
    v-if="label"
    class="CardLabel label"
    :class="label.class"
    :style="label.style">
    {{ label.text | translate }}
  </div>
</template>

<script>
export default {
  name: 'card-label',
  props: {
    label: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
</style>
